export const fuseProvisioningConstants = {
  FUSE_PROVISIONING_LOADING: "FUSE_PROVISIONING_LOADING",
  FUSE_PROVISIONING_SUCCESS: "FUSE_PROVISIONING_SUCCESS",
  FUSE_PROVISIONING_FAILURE: "FUSE_PROVISIONING_FAILURE",
};
